const splitTermTitle = (termTitle: string) => {
  const shortPartStartIndex = termTitle.indexOf('(');
  const shortTermStartPos = shortPartStartIndex >= 0 ? shortPartStartIndex : termTitle.length;
  const shortTerm = termTitle.substring(shortTermStartPos, termTitle.length).replace(/\(|\)/g, '');
  const longTerm = termTitle.substring(0, shortTermStartPos);

  return [longTerm, shortTerm].map((term) => term.trim()).filter(Boolean);
};

export default splitTermTitle;
